function escapeCsvString(item: string) {
  // CSV string escaping for `,`, `'`, and `"` characters:
  const csvString = item ?? '';

  return csvString.replace(/"/g, '""').replace(/,/g, ',').replace(/'/g, "'");
}

function buildCsvHeaderFromObjectMap<T>(data: T[]): string {
  return `${Object.keys(data[0] as unknown as object).join(',')}\n`;
}

export function buildCsvFromObjectMap<T>(data: T[]): string {
  if (!data.length) return '';

  const entityList = data.map((item: T) => {
    return Object.values(item as unknown as object);
  });

  let csv = buildCsvHeaderFromObjectMap<T>(data);

  entityList.forEach((row: string[]) => {
    row.forEach((item: string, index) => {
      csv += `"${escapeCsvString(item)}"${index === row.length - 1 ? '' : ','}`;
    });
    csv += `\n`;
  });

  return csv;
}
